import { useQuery } from '@apollo/client';
import {
    MerchantFieldsFragment,
    MerchantsForIdsDocument,
    TransactionEntryRuleFieldsFragment,
} from '../../../graphql/generated';
import { getIsValidUuid } from '../../../util/strings';

// Fetch merchants for all merchantIds in all rule's changesets and return a map of merchant id --> merchant
export const useMerchantsMap = (
    rules: Pick<TransactionEntryRuleFieldsFragment, 'changeset'>[]
) => {
    const merchantIds = new Set(
        rules.flatMap((rule) =>
            rule.changeset
                .filter(
                    (change) =>
                        change.field === 'merchantId' &&
                        getIsValidUuid(change.value)
                )
                .map((change) => change.value as string)
        )
    );

    const { data: merchantsData, loading: merchantsLoading } = useQuery(
        MerchantsForIdsDocument,
        {
            variables: {
                ids: merchantIds.size ? Array.from(merchantIds) : [],
            },
        }
    );

    const merchantsMap = merchantsData?.merchants
        ? merchantsData.merchants.reduce(
              (acc, merchant) => {
                  acc[merchant.id] = merchant;
                  return acc;
              },
              {} as Record<string, MerchantFieldsFragment>
          )
        : {};
    return { merchantsLoading, merchantsMap };
};
